export default __webpack_public_path__ + "maps-examples-view-annotation-basic-1200-59aa5ad508a0c91123c34686592485b8.png";